module.exports = __webpack_public_path__ + "fonts/nunito-sans-v11-latin-regular.bede8300.eot";